<style lang="scss">
    .download-button {
        padding: 5px;
    }
</style>

<template>
    <a class="download-button" href="javascript:;" @click="download">
        <font-awesome-icon v-if="item.loadingDownload" icon="spinner-third" spin fixed-width></font-awesome-icon>
        <font-awesome-icon v-else icon="download" fixed-width></font-awesome-icon>
        <slot name="label"></slot>
    </a>
</template>

<script>
    export default {
        props: ['item'],
        computed: {
            downloadModal() {
                return this.$store.state.downloadModal
            }
        },
        methods: {
            download(event) {
                this.item.loadingDownload = true;

                this.$http.get(`/freedownloads/${this.item.getType()}/${this.item.id}`)
                    .then((response) => {
                        this.$store.commit("downloadable", {downloadable: {
                            music: this.item,
                            exchange: response.data
                        }});

                        this.downloadModal.modal('show');

                        this.item.loadingDownload = false;
                    })
                    .catch((error) => {
                        this.item.loadingDownload = false;
                    });

                event.stopPropagation();
            },
        }
    }
</script>